import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from "@angular/core";

import { Subscription } from "rxjs";
import {
  MainMenuItems,
  A2ZUSMenuItems,
  EagleMenuItems
} from "../../../core/constants/menu";
import { LogoPath, UserimgPath } from "../../../core/constants/image";
import { LoginLink, UserType } from "../../../core/constants/common";
import {
  AuthService,
  SharedVarService,
  MasterA2ZService,
  MasterHospitalService,
  CommonService,
  SnackService,
  User,
  DateTimeService
} from "@school/a2z-lib";
import { Router } from "@angular/router";


@Component({
  selector: "school-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.scss"]
})
export class AsideComponent implements OnInit, OnDestroy {

  fullName: any;

  asideClasses = '';
  designation = '';
  userimg = '';
  selectedmenuvalue: string;
  signoutlink = LoginLink;
  logovalue = LogoPath;
  Menulists = MainMenuItems;
  userSub: Subscription;
  chkGender: string;
  board_type: string;
  defaultAvatar: string = 'blank.png';

  @Output() menuEvent = new EventEmitter<string>();

  constructor(private authService: AuthService,
    private _userService: CommonService,
    private _snackService: SnackService,
    private _authService: MasterA2ZService,
    private _authHospitalService: MasterHospitalService,
    private router: Router,
    private _dateTimeService: DateTimeService,
    private SharedVarservice: SharedVarService) {
  }

  ngOnInit() {
    this.fullName = 'Name';
    this.designation = 'Super Admin';
    this.Menus();

    this.profileImg();
    this.Menulists.forEach(element => {
      if (element.urlLink == this.router.url) {
        this.Menuclick(element.title);
      }
    });


    this.SharedVarservice.getValue().subscribe((value: any) => {
      if (typeof (value) == 'object') {
        this.Menus(value.entity_name);
        this.board_type = value.type;
      } else {
        this.LoadData();
      }
    });

    this.userSub = this.authService.user.subscribe(user => {
      if (!user) {
        return;
      }

      this.fullName = user.name;
      this.designation = user.role;

      if (user.profileImage) {
        this.userimg = 'url(' + user.profileImage + ')';
      }
    });

  }

  Menus(key?: string): void {

    if ((key == null || key == undefined) && localStorage.getItem('currentApp' + UserType) != null) {
      key = localStorage.getItem('currentApp' + UserType);
    }
    if (localStorage.getItem('currentApp' + UserType) == null) {
      key = 'main';
    }

    switch (key) {
      case 'a2z_us':
        this.Menulists = A2ZUSMenuItems;
        this.Menuclick('A2Z US Provider');
        break;
      case 'eagle':
        this.Menulists = EagleMenuItems;
        this.Menuclick('Hospital Eagle Group');
        break;

      default:
        this.Menulists = MainMenuItems;
        this.Menuclick('Apps');
        break;
    }

  }

  profileImg() {


    this.userSub = this.authService.user.subscribe(user => {

      this.chkGender = user.gender;
      if (this.chkGender.toLowerCase() == 'female') {
        this.defaultAvatar = 'woman.png';
      }

      if (this.chkGender.toLowerCase() == 'male') {
        this.defaultAvatar = 'man.png';
      }
      this.userimg = 'url(' + UserimgPath + this.defaultAvatar + ')';
    });
  }

  LoadData() {

    this._userService.getLoginUserInfos().subscribe(
      result => {

      const userData: {
        name: string;
        last_name: string;
        email: string;
        profileImage: string;
        gender: string;
        role: string;
        timezone: any;
        is2fa: boolean;
        _token: string;
        _tokenExpirationDate: Date;
      } = JSON.parse(localStorage.getItem('userData' + UserType));


        console.log(userData,'fff')
        console.log(result.body.data.last_name,';;;;')
        this.fullName = result.body.data.first_name + ' ' + result.body.data.last_name;


        if (result.body.data.profile_image) {
          this.userimg = 'url(' + result.body.data.profile_image + ')';
        }

        userData.name = result.body.data.first_name + ' ' + result.body.data.last_name;
        userData.email = result.body.data.email;
        userData.profileImage = result.body.data.profile_image;
        userData.timezone = result.body.data.timezone;
        userData.gender = result.body.data.gender;

const user = new User(
  userData.name,
  userData.last_name,
  userData.email,
  userData.profileImage,
  userData.gender,
  userData.role,
  userData.timezone,
  userData.is2fa,
  userData._token,
  userData._tokenExpirationDate
);
        this.authService.user.next(user);
        this._dateTimeService.format = this._dateTimeService.getFormat();

        localStorage.setItem('userData' + UserType, JSON.stringify(userData));
        if (!result.body.data.profile_image) {
          this.profileImg();
        }

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load updated data..");
      });

  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  Menuclick(menutitle: any) {
    this.menuEvent.emit(menutitle);
  }

  identify(index, item) {
    return item.id;
  }


}
